import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faChalkboardTeacher, faTools, faCalendar, faClock, faUser, faMoneyBill, faCalendarCheck } from "@fortawesome/free-solid-svg-icons";

const AgriLinkTrainingWorkshop = () => {
  const navigate = useNavigate();
  const [activeTab, setActiveTab] = useState("trainings");
  const [selectedItem, setSelectedItem] = useState(null);

  const trainings = [
  {
    id: 1,
    title: "Smart Farming & AgriTech Basics",
    mode: "Online",
    date: "25 Oct 2025",
    time: "6:00 PM - 8:00 PM",
    organizer: "KrishiVikas Academy",
    fee: "₹499",
    lastDate: "24 Oct 2025",
    description:
      "Learn how to integrate digital tools, IoT, and data-driven decision-making for improved productivity in modern agriculture.",
  },
  {
    id: 2,
    title: "Rural Finance & Agri Credit Management",
    mode: "Online",
    date: "28 Oct 2025",
    time: "5:00 PM - 7:00 PM",
    organizer: "NABARD Learning Hub",
    fee: "Free",
    lastDate: "27 Oct 2025",
    description:
      "Gain practical insights into crop loans, KCC, microfinance, and financial planning for small farmers and agri-entrepreneurs.",
  },
  {
    id: 3,
    title: "Agri Business Planning & Marketing",
    mode: "Online",
    date: "30 Oct 2025",
    time: "4:00 PM - 6:00 PM",
    organizer: "AgroStart Foundation",
    fee: "₹299",
    lastDate: "29 Oct 2025",
    description:
      "Step-by-step guidance on developing agri business models, value chains, and marketing strategies for rural startups.",
  },
];

const workshops = [
  {
    id: 1,
    title: "Vermicomposting & Organic Fertilizer Making",
    mode: "Offline",
    date: "26 Oct 2025",
    time: "3:00 PM - 5:00 PM",
    organizer: "GreenSoil Collective",
    fee: "₹399",
    lastDate: "25 Oct 2025",
    description:
      "Hands-on workshop to create eco-friendly compost using farm waste — enhance soil fertility and income sustainability.",
  },
  {
    id: 2,
    title: "Dairy & Goat Farming for Beginners",
    mode: "Hybrid",
    date: "29 Oct 2025",
    time: "2:00 PM - 4:00 PM",
    organizer: "Rural Livelihood Centre",
    fee: "₹299",
    lastDate: "28 Oct 2025",
    description:
      "Learn animal care, feed management, and marketing methods to start and manage a profitable dairy or goat farming business.",
  },
  {
    id: 3,
    title: "Agri Processing & Value Addition",
    mode: "Offline",
    date: "31 Oct 2025",
    time: "5:30 PM - 7:30 PM",
    organizer: "AgriSkill Workshop",
    fee: "₹499",
    lastDate: "30 Oct 2025",
    description:
      "Practical training on processing, packaging, and branding farm products to increase income through local agri-value chains.",
  },
];


  const dataToShow = activeTab === "trainings" ? trainings : workshops;

  return (
    <div className="min-h-screen bg-gray-950 text-green-100 flex flex-col items-center p-4">
      <h2 className="text-2xl font-semibold mb-4 text-green-300">
        Farm & Rural Training & Workshops
      </h2>

      {/* Tabs */}
      <div className="grid grid-cols-2 w-full sm:w-1/2 gap-2 mb-6">
        <button
          onClick={() => {
            setSelectedItem(null);
            setActiveTab("trainings");
          }}
          className={`py-2 rounded-md font-semibold flex items-center justify-center gap-2 transition ${
            activeTab === "trainings"
              ? "bg-green-600 text-white"
              : "bg-gray-800 text-green-300 hover:bg-gray-700"
          }`}
        >
          <FontAwesomeIcon icon={faChalkboardTeacher} /> Trainings
        </button>

        <button
          onClick={() => {
            setSelectedItem(null);
            setActiveTab("workshops");
          }}
          className={`py-2 rounded-md font-semibold flex items-center justify-center gap-2 transition ${
            activeTab === "workshops"
              ? "bg-green-600 text-white"
              : "bg-gray-800 text-green-300 hover:bg-gray-700"
          }`}
        >
          <FontAwesomeIcon icon={faTools} /> Workshops
        </button>
      </div>

      {/* List or Details */}
      <div className="w-full sm:w-3/4 lg:w-1/2">
        {!selectedItem ? (
          <div className="space-y-3">
            {dataToShow.map((item) => (
              <div
                key={item.id}
                onClick={() => setSelectedItem(item)}
                className="bg-gray-900 border border-gray-700 hover:border-green-500 transition rounded-lg p-4 cursor-pointer"
              >
                <h3 className="text-lg font-semibold text-green-300 mb-2">
                  {item.title}
                </h3>
                <div className="text-sm space-y-1">
                  <p>
                    <FontAwesomeIcon icon={faClock} className="mr-2 text-green-400" />
                    Mode: {item.mode}
                  </p>
                  <p>
                    <FontAwesomeIcon icon={faCalendar} className="mr-2 text-green-400" />
                    Date: {item.date}
                  </p>
                  <p>
                    <FontAwesomeIcon icon={faUser} className="mr-2 text-green-400" />
                    Organizer: {item.organizer}
                  </p>
                  <p>
                    <FontAwesomeIcon icon={faMoneyBill} className="mr-2 text-green-400" />
                    Entry Fee: {item.fee}
                  </p>
                  <p>
                    <FontAwesomeIcon icon={faCalendarCheck} className="mr-2 text-green-400" />
                    Last Date: {item.lastDate}
                  </p>
                </div>
              </div>
            ))}
          </div>
        ) : (
          <div className="bg-gray-900 border border-green-600 rounded-lg p-4 text-sm">
            <h3 className="text-lg font-semibold text-green-300 mb-2">
              {selectedItem.title}
            </h3>
            <div className="space-y-1 mb-3">
              <p>
                <FontAwesomeIcon icon={faClock} className="mr-2 text-green-400" />
                Mode: {selectedItem.mode}
              </p>
              <p>
                <FontAwesomeIcon icon={faCalendar} className="mr-2 text-green-400" />
                Date: {selectedItem.date}
              </p>
              <p>
                <FontAwesomeIcon icon={faUser} className="mr-2 text-green-400" />
                Organizer: {selectedItem.organizer}
              </p>
              <p>
                <FontAwesomeIcon icon={faMoneyBill} className="mr-2 text-green-400" />
                Entry Fee: {selectedItem.fee}
              </p>
              <p>
                <FontAwesomeIcon icon={faCalendarCheck} className="mr-2 text-green-400" />
                Last Date: {selectedItem.lastDate}
              </p>
            </div>
            <p className="text-gray-300 mb-4">{selectedItem.description}</p>

            <div className="flex flex-col sm:flex-row justify-center gap-3">
              <button
                onClick={() => setSelectedItem(null)}
                className="bg-gray-700 hover:bg-gray-600 text-white px-4 py-2 rounded-md font-medium transition"
              >
                Close
              </button>
              <button
                onClick={() => navigate("/enroll/workshop")}
                className="bg-green-600 hover:bg-green-700 text-white px-4 py-2 rounded-md font-medium transition"
              >
                Enroll
              </button>
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default AgriLinkTrainingWorkshop;
